import ListItemText from "@material-ui/core/ListItemText";
import React from "react";
import { useQuery } from "react-query";
import { Field } from "redux-form";
import airportList from "../../../constants/airports.json";
import popularPlacesList from "../../../constants/popularPlaces.json";
import { PlaceType } from "../../../constants/PlaceType";
import { useDebounce } from "../../../hooks";
import { useGetRecentPlacesList } from "../../../hooks/recentPlaces";
import { useGetSavedPlacesList } from "../../../hooks/savedPlaces";
import { getSuggestion } from "../../../services/googleMap";
import Autocomplete from "../AutocompleteField";
import { FormNumberField } from "../index";
import styles from "./style.module.css";
import uniqBy from "lodash.uniqby";
import renderIconType from "./renderIconType";
import Airport from "../../../forms/Reservation/Airport";
import { StyledMenuItem } from "./StyledMenuItem";

export default function RoutePointField(props) {
  const [ inputValue, setInputValue ] = React.useState("");
  const recentPlaces = useGetRecentPlacesList();
  const savedPlaces = useGetSavedPlacesList();

  const assignProp = (prop) => {
    return ({
      ...props.value,
      ...prop,
    });
  };
  const regularAirport = props.value?.placeType === PlaceType.AIRPORT && airportList.find(item => item.zip === props.value?.address?.zip);

  const debouncedInputValue = useDebounce(inputValue, 1000);
  const { data: suggestions, isLoading } = useQuery(
    [ "suggestions", debouncedInputValue ],
    getSuggestion,
    {
      retry: false,
      refetchOnWindowFocus: false,
      queryFnParamsFilter: args => args.slice(1),
    });

  const isOptionLoading = isLoading || debouncedInputValue !== inputValue;

  const options = React.useMemo(() => {
    if (!inputValue) {
      return uniqBy([
        ...recentPlaces,
        ...savedPlaces,
        ...popularPlacesList[0].places,
      ], x => x?.description);
    }
    return suggestions || [];
  }, [ recentPlaces, savedPlaces, popularPlacesList, suggestions, inputValue ]);

  return (
    <>
      <Autocomplete
        style={{ width: "100%" }}
        getOptionLabel={(option) => (typeof option === "string" ? option : option?.address?.full)}
        options={options}
        value={props.value?.address?.full}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        autoComplete
        includeInputInList
        filterSelectedOptions
        filterOptions={x => x}
        loading={isOptionLoading}
        label={props.placeholder}
        onBlur={props.onBlur}
        onFocus={props.onFocus}
        onChange={(e, value) => {
          const newValue = value ? {
            ...value,
            seqType: props.dropOff ? "DO" : "PU",
          } : null;
          if (newValue?.placeType === PlaceType.AIRPORT) {
            newValue.airport.noFlight = !!props.dropOff;
          }
          return props.onChange(newValue);
        }
        }
        renderOption={(option) =>
          <StyledMenuItem>
            {renderIconType(option?.type)}
            <ListItemText
              primary={option?.address?.full}
              disableTypography
            />
          </StyledMenuItem>}
      />
      {
        (() => {
          if (props.value?.placeType === PlaceType.AIRPORT) {
            if (!props.dropOff) {
              if (!!regularAirport) {
                return (
                  <Airport
                    airport={regularAirport}
                    {...props}
                    onChange={(value) => props.onChange(assignProp({ airport: value }))}
                  />
                );
              }
              if (!props.value.airport.iata) {
                return (
                  <div className={styles.terminal}>
                    <Field
                      label="Tail number"
                      component={FormNumberField}
                      name="routePoints[0].airport.terminal"
                    />
                  </div>
                );
              }
            } else {
              return (
                <div className={styles.terminal}>
                  <Field
                    label="Terminal"
                    component={FormNumberField}
                    name="routePoints[1].airport.terminal"
                  />
                </div>
              );
            }
          }
          return null;
        })()
      }
    </>
  );
};
